import { ReactNode } from 'react'

import { CheckboxFilterItem } from './CheckboxFilterItem'
import { ColorFilterItem } from './ColorFilterItem'
import * as Styles from './styles'

export type FilterListProps = {
  /* The number of filter menu items that are displayed within the list. */
  count: number
  /* The filter menu items. */
  children: ReactNode
}

/* Wrapper for a list of filter menu items. */
function List({ count, children }: FilterListProps) {
  const mobileColumnDisplayLength = count >= 8 ? Math.ceil(count / 2) : count

  return (
    <Styles.List mobileColumnDisplayLength={mobileColumnDisplayLength} columnDisplayLength={count}>
      {children}
    </Styles.List>
  )
}

export const FilterList = {
  List,
  CheckboxItem: CheckboxFilterItem,
  ColorItem: ColorFilterItem,
}
